import { BtnMyLocation, Logo, MapView, SearchBar } from "../components"

export const HomeScreen = () => {
  return (
    <div>
        <SearchBar/>
        <MapView/>
        <BtnMyLocation/>
        <Logo/>
    </div>
  )
}
